import React, { useCallback } from 'react';

import { Field } from 'react-final-form';
import FormInput from 'Shared/components/FormComponents/FormInput';
import {
  validEmailOrEmptyRequired,
  useValidator,
  nonConsistsOfAllSpacesStringRequired,
} from 'Shared/utils/formValidations';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';

type PropType = {
  remove: Function;
  name: string;
  fieldsCount: number;
  index: number;
  required?: boolean;
};

function FormWorkspaceField({ name, remove, fieldsCount, index, required = false }: PropType) {
  const emailValidate = useValidator(validEmailOrEmptyRequired, 'Invalid Email');
  const nameValidate = useValidator(nonConsistsOfAllSpacesStringRequired, 'This field is required');

  const handleRemove = useCallback(() => {
    remove(index);
  }, [remove, index]);

  return (
    <div key={name} className="mobile-onboarding-workspace-options mb-2">
      <div className="d-flex">
        <div className="w-100">
          <Field
            name={`${name}.fullName`}
            placeholder="Full name"
            label="Name"
            autoComplete="off"
            className="mt-2 mb-1"
            component={FormInput}
            validate={nameValidate}
            labelMuted
            required={required}
            labelRequired={required ? '*Required' : null}
          />

          <Field
            name={`${name}.email`}
            placeholder="Email (optional)"
            validate={emailValidate}
            label="Email"
            component={FormInput}
            autoComplete="off"
            labelMuted
          />
        </div>

        {fieldsCount > 1 && (
          <div className="mt-4 pt-2">
            <WpButton variant="tertiary" color="danger" qaTest="workspace-field-remove" onClick={handleRemove}>
              <WpIcon name="trash" />
            </WpButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default FormWorkspaceField;
